import React from 'react';
import Login from '../../components/Login';
import { useNavigate } from 'react-router-dom';
import { useDatabaseContext } from '../../contexts/DatabaseContext';

const LoginPage: React.FC = () => {
  const navigate = useNavigate();
  // Auth context used implicitly through Login component
  const { fetchDatabases, setActiveDatabase } = useDatabaseContext();

  const handleLoginSuccess = async () => {
    try {
      // After AuthContext login, fetch user and databases
      const databases = await fetchDatabases();
      if (databases.length > 0) {
        setActiveDatabase(databases[0]);
      }
    } catch (error) {
      console.error('Erreur lors de la récupération des bases de données:', error);
    }
    navigate('/mes-donnees');
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <Login onLoginSuccess={handleLoginSuccess} />
    </div>
  );
};

export default LoginPage;
